import baseRequest from './baseRequest';

const SSO_API_URL = '/api/public/sso';

export async function ssoCheck(username: string) {
  return await baseRequest.get(SSO_API_URL, {
    params: { username },
  });
}
